document.addEventListener('DOMContentLoaded', () => {
  const initSection = (section) => {
    const sectionId = section.dataset.section;
    const prefix = section.dataset.btnPrefix || 'Add to cart';
    const selectSizeLabel = section.dataset.btnSelectSize || 'Select a size';
    const deselectSize = section.dataset.deselectSize === 'true';
    const submitBtn = section.querySelector('.product-form__submit span');
    const compareEl = section.querySelector('[data-compare-price]');
    const stickyPriceEl = section.querySelector('[data-sticky-price]');
    const stickyCompareEl = section.querySelector('[data-sticky-compare]');
    const stickyAtcBtn = section.querySelector('[data-sticky-atc]');
    const stickyDoor = section.querySelector('.sticky-bar-btn-door');
    const stickyBar = section.querySelector('.sun-protection-sticky-bar');
    const middlePartContainer = section.querySelector('.middle-part-container');
    const middlePart = section.querySelector('.middle-part');
    const mobileBgBlack = section.querySelector('.mobile-bg-black');
    const mobileCloseChoose = section.querySelector('.mobile-close-choose');

    const sizeSwatch = () => section.querySelector('.size-swatch');

    const isSizeSelected = () => {
      if (!deselectSize) return true;
      const swatch = sizeSwatch();
      return swatch ? !!swatch.querySelector('input:checked') : true;
    };

    const showChooseTips = () => {
      const swatch = sizeSwatch();
      if (!swatch) return;
      swatch.classList.add('choose-tips');
      window.chooseTipsActive = true;
    };

    const clearChooseTips = () => {
      sizeSwatch()?.classList.remove('choose-tips');
      window.chooseTipsActive = false;
    };

    const getDisplayedPrice = () => {
      const priceRoot = section.querySelector(`#price-${sectionId}`);
      if (!priceRoot) return '';

      const priceItem =
        priceRoot.querySelector('.price-item--last') ||
        priceRoot.querySelector('.price-item--regular') ||
        priceRoot.querySelector('.price__regular .price');

      return priceItem?.textContent?.replace(/\s+/g, ' ').trim() || '';
    };

    const formatVariantMoney = (cents) => {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        const format =
          window.theme?.moneyFormat ||
          window.Shopify?.money_format ||
          '${{amount}}';
        return Shopify.formatMoney(cents, format);
      }
      return (cents / 100).toFixed(2);
    };

    const updateStickyDoor = () => {
      if (!stickyDoor) return;
      const drawerOpen = section.classList.contains('is-variant-drawer-open');
      const showDoor = drawerOpen ? !isSizeSelected() : true;
      stickyDoor.classList.toggle('hidden', !showDoor);
      stickyDoor.setAttribute('aria-hidden', showDoor ? 'false' : 'true');
    };

    const updateStickyBarHeight = () => {
      if (!stickyBar) return;
      const height = stickyBar.offsetHeight;

      if (section.classList.contains('is-variant-drawer-open')) {
        section.style.setProperty('--sticky-bar-height', `${height}px`);
      }
    };

    const openVariantDrawer = () => {
      if (!middlePartContainer || !middlePart) return;
      section.classList.add('is-variant-drawer-open');
      updateStickyBarHeight();
      middlePart.classList.add('active');
      mobileBgBlack?.classList.add('active');
      document.body.classList.add('overflow-hidden');
      updateStickyDoor();
      window.requestAnimationFrame(() => {
        updateStickyBarHeight();
        updateStickyDoor();
      });
    };

    const closeVariantDrawer = () => {
      section.classList.remove('is-variant-drawer-open');
      section.style.removeProperty('--sticky-bar-height');
      middlePart?.classList.remove('active');
      mobileBgBlack?.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      clearChooseTips();
      updateStickyDoor();
    };

    let resizeTimer;
    const handleResize = () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        updateStickyBarHeight();
      }, 150);
    };

    const updateSubmitLabel = (variant) => {
      if (!submitBtn || submitBtn.closest('.product-form__submit')?.disabled) return;

      if (deselectSize && !isSizeSelected()) {
        submitBtn.textContent = selectSizeLabel;
        return;
      }

      const priceText = getDisplayedPrice();
      if (!priceText) return;

      if (
        variant &&
        (variant.available === false ||
          (variant.inventory_quantity === 0 && variant.inventory_policy !== 'continue'))
      ) {
        return;
      }

      submitBtn.textContent = `${prefix} — ${priceText}`;
    };

    const updateComparePrice = (variant) => {
      if (!compareEl || !variant) return;

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const compareNode = section.querySelector(`#price-${sectionId} s.price-item--regular`);
        compareEl.textContent = compareNode?.textContent?.trim() || compareEl.textContent;
        compareEl.classList.remove('hidden');
      } else {
        compareEl.classList.add('hidden');
      }
    };

    const updateStickyPrice = (variant) => {
      if (!stickyPriceEl || !variant) return;

      stickyPriceEl.textContent = getDisplayedPrice() || formatVariantMoney(variant.price);

      if (stickyCompareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          stickyCompareEl.textContent = formatVariantMoney(variant.compare_at_price);
          stickyCompareEl.classList.remove('hidden');
        } else {
          stickyCompareEl.classList.add('hidden');
        }
      }
    };

    const handleVariantChange = (event) => {
      if (event?.data?.sectionId !== sectionId) return;

      window.requestAnimationFrame(() => {
        updateComparePrice(event.data.variant);
        updateStickyPrice(event.data.variant);
        updateSubmitLabel(event.data.variant);
        updateStickyDoor();
      });
    };

    const handleOptionChange = (event) => {
      if (!section.contains(event?.data?.event?.target)) return;

      window.requestAnimationFrame(() => {
        if (isSizeSelected()) {
          clearChooseTips();
        }
        updateSubmitLabel();
        updateStickyDoor();
      });
    };

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, handleVariantChange);
      if (deselectSize) {
        subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, handleOptionChange);
      }
    }

    stickyDoor?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const drawerOpen = section.classList.contains('is-variant-drawer-open');
      if (drawerOpen && deselectSize && !isSizeSelected()) {
        showChooseTips();
        return;
      }

      if (!drawerOpen) {
        openVariantDrawer();
      }
    });

    stickyAtcBtn?.addEventListener('click', (event) => {
      if (stickyDoor && !stickyDoor.classList.contains('hidden')) return;

      event.preventDefault();
      const formSubmit = section.querySelector('.product-form__submit:not([disabled])');
      formSubmit?.click();
    });

    mobileBgBlack?.addEventListener('click', (event) => {
      if (!section.classList.contains('is-variant-drawer-open')) return;
      event.preventDefault();
      event.stopPropagation();
      closeVariantDrawer();
    });

    mobileCloseChoose?.addEventListener('click', (event) => {
      if (!section.classList.contains('is-variant-drawer-open')) return;
      event.preventDefault();
      event.stopPropagation();
      closeVariantDrawer();
    });

    // Safari on iOS blocks variant drawer from closing when cart drawer is opened
    const isIPhoneSafari =
      /iPhone/.test(navigator.userAgent) &&
      navigator.vendor === 'Apple Computer, Inc.' &&
      !navigator.userAgent.includes('CriOS') &&
      !navigator.userAgent.includes('FxiOS') &&
      !navigator.userAgent.includes('EdgiOS');
    if (isIPhoneSafari) {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        let cartDrawerWasActive = cartDrawer.classList.contains('active');
        const cartDrawerObserver = new MutationObserver(() => {
          const isActive = cartDrawer.classList.contains('active');
    
          if (cartDrawerWasActive && !isActive) {
            closeVariantDrawer();
          }
          cartDrawerWasActive = isActive;
        });
        cartDrawerObserver.observe(cartDrawer, {
          attributes: true,
          attributeFilter: ['class'],
        });
      }
    }

    const initialVariantScript = section.querySelector('variant-selects [data-selected-variant]');
    if (initialVariantScript) {
      try {
        const variant = JSON.parse(initialVariantScript.textContent);
        updateComparePrice(variant);
        updateStickyPrice(variant);
        updateSubmitLabel(variant);
      } catch (error) {
        updateSubmitLabel();
      }
    } else {
      updateSubmitLabel();
    }

    updateStickyDoor();
    updateStickyBarHeight();
    window.addEventListener('resize', handleResize);
  };

  document.querySelectorAll('product-info.sun-protection-buy').forEach(initSection);
});
